import {Button, Form, Input, InputNumber, Switch, Tag} from 'antd';
import {fieldRules} from 'utils/helper';
import {IconEditor} from './IconEditor';
import styles from './FlowBuilder.module.scss';

export const FeatureForm = ({
  form,
  mode,
  language,
  parentCategory,
  onFinish,
  submitting,
}) => {
  const isEdit = mode === 'edit';
  return (
    <div className={styles.formRoot}>
      <div className={styles.formHeader}>
        <h2>{isEdit ? 'Update Feature' : 'Create Feature'}</h2>
        {parentCategory ? (
          <p className={styles.formContext}>
            {isEdit ? 'in' : 'under'} <strong>{parentCategory.name}</strong> ·{' '}
            {language}
          </p>
        ) : null}
      </div>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name="name" label="Name" rules={[fieldRules('Name')]}>
          <Input placeholder="e.g. Bank Deposits" />
        </Form.Item>
        <Form.Item name="iconUrl" label="Icon">
          <IconEditor />
        </Form.Item>
        <Form.Item
          name="sortOrder"
          label="Sort order"
          rules={[{type: 'number', min: 1, message: 'Must be at least 1'}]}>
          <InputNumber min={1} style={{width: '100%'}} />
        </Form.Item>
        <Form.Item name="isActive" label="Active" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item
          name="availableToAnonymous"
          label="Available to anonymous"
          valuePropName="checked"
          tooltip="Expose to logged-out users. Only takes effect if the parent category is also flagged available to anonymous.">
          <Switch />
        </Form.Item>
        <div className={styles.formActions}>
          <Tag color="blue">{language}</Tag>
          <Button type="primary" htmlType="submit" loading={submitting}>
            {isEdit ? 'Save Changes' : 'Create'}
          </Button>
        </div>
      </Form>
    </div>
  );
};
